import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import ModalService from 'services/modal';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import SupplierService from 'services/supplier';

function PenaltyNoticeDetail(props) {
  const Config = {
    purchase: {
      title: '供应商违约/索赔通知',
      apiPath: '/b2bPunishNotice/detail',
      publishApiPath: '/b2bPunishNotice/publish',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_punish_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'pnhXkNo',
      wfmCode: '1020'
    },
    sale: {
      title: '供应商违约/索赔通知',
      apiPath: '/b2bCustomerPunishNotice/detail',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_punish_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'pnhXkNo'
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    // getList();
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  function validate() {
    let taxFlag = false;
    let categoryFlag = false;
    list.forEach(item => {
      if (Util.isEmpty(item.taxCode)) {
        taxFlag = true;
      }
      if (Util.isEmpty(item.categoryCode)) {
        categoryFlag = true;
      }
    });
    if (categoryFlag) {
      ModalService.showError('单身品类不能为空', dispatch);
      return false;
    }
    if (taxFlag) {
      ModalService.showError('单身税别不能为空', dispatch);
      return false;
    }

    return true;
  }

  //发布
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    SupplierService.publishPenaltyNotice(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      pnhXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">
                    {self.isPurchase ? '供应商名称' : '客户名称'}
                  </span>
                  {self.isPurchase && (
                    <div className="field-value">
                      {detail.innerVendorCode} {detail.innerVendorName}
                    </div>
                  )}
                  {!self.isPurchase && (
                    <div className="field-value">
                      {detail.innerCustomerCode} {detail.innerCustomerName}
                    </div>
                  )}
                </li>
                <li>
                  <span className="field-label">通知标题</span>
                  <div className="field-value">{detail.punishTitle}</div>
                </li>
                <li>
                  <span className="field-label">通知单号</span>
                  <div className="field-value">{detail.pnhInnerNo}</div>
                </li>
                <li>
                  <span className="field-label">关联费用单</span>
                  <div className="field-value">{detail.csoXkNo}</div>
                </li>
                <li>
                  <span className="field-label">工厂/BU</span>
                  <div className="field-value">{detail.profitCenterName}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_punish_Status',
                          detail.status
                        )
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>

                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/*商城引入明细 */}
        {!Util.isEmpty(detail.lineList) && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>处罚明细</label>
            </div>

            <div className="details-item-content">
              {detail.lineList.map((item, index) => (
                <div className="content-line line-list-item" key={index}>
                  <div className="line-list-item-title">序号 {index + 1}</div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">编码</span>
                      <div className="field-value">{item.punishItemCode}</div>
                    </li>
                    <li>
                      <span className="field-label">处罚事项</span>
                      <div className="field-value">{item.punishItemName}</div>
                    </li>
                    <li>
                      <span className="field-label">处罚标准（扣分）</span>
                      <div className="field-value">
                        {item.deductScoreStart}-{item.deductScoreEnd}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">处罚标准（罚款）</span>
                      <div className="field-value">
                        {item.deductAmountStart}-{item.deductAmountEnd}
                      </div>
                    </li>

                    <li>
                      <span className="field-label">绩效扣分</span>
                      <div className="field-value">
                        {formatNumber(
                          item.deductAssessmentScore,
                          decimalPlace.QTY
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">罚款金额</span>
                      <div className="field-value">
                        {formatNumber(item.deductAmount, decimalPlace.AMOUNT)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">费用原因</span>
                      <div className="field-value">
                        {item.costReasonEnumValue}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">说明</span>
                      <div className="field-value">{item.punishItemDesc}</div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="m-details-item">
          <div className="details-item-title">
            <label>合计</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">绩效扣分</span>
                  <div className="field-value">
                    {formatNumber(
                      detail.totDeductAssessmentScore,
                      decimalPlace.QTY
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">罚款金额</span>
                  <div className="field-value">
                    {formatNumber(detail.totDeductAmount, decimalPlace.AMOUNT)}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>处罚说明</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label"></span>
                  <div className="field-value">{detail.punishDesc}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>供应商回复</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label"></span>
                  <div className="field-value">{detail.answerDesc}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {self.isPurchase && (
          <div className="m-details-item">
            <div className="details-item-title">
              <label>备注说明（内部查看）</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label"></span>
                    <div className="field-value">{detail.remark}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10051803') &&
            (([0, 2].includes(detail.status) &&
              workflow.data?.punish_notice_publish?.complete) ||
              ([3].includes(detail.status) &&
                workflow.data?.punish_notice_returnPublish?.complete)) && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
        </div>
      )}

      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

PenaltyNoticeDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PenaltyNoticeDetail);
